"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectStore = exports.SelectContainer = exports.SelectSubscriber = exports.selectRegistryStore = exports.SELECT_STORE_NAME = void 0;
const react_sweet_state_1 = require("react-sweet-state");
const actions_1 = require("./actions");
const state_1 = require("./state");
exports.SELECT_STORE_NAME = 'monera-select-registry-store';
exports.selectRegistryStore = (0, react_sweet_state_1.createStore)({
    actions: actions_1.selectActions,
    initialState: state_1.initialSelectState,
    name: exports.SELECT_STORE_NAME
});
exports.SelectSubscriber = (0, react_sweet_state_1.createSubscriber)(exports.selectRegistryStore);
exports.SelectContainer = (0, react_sweet_state_1.createContainer)(exports.selectRegistryStore, {
    onInit: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialSelectState),
    onUpdate: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialSelectState)
});
exports.useSelectStore = (0, react_sweet_state_1.createHook)(exports.selectRegistryStore);
__exportStar(require("./selectors"), exports);
__exportStar(require("./types"), exports);
